import React, { useState, useEffect } from 'react';
import homebanner1 from '../../assets/images/homebanner2 copy.webp';
import homebanner2 from '../../assets/images/Main_Banner_4.jpg';
import '../../components/HomePage/HomePage.css';
import '../../styles/CustomClassCss/Custom.css';
import { FaSearch, FaHeadphonesAlt } from "react-icons/fa";
import { MdOutlineArrowOutward, MdEmail } from "react-icons/md";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { MdKeyboardArrowRight } from "react-icons/md";
import { IoClose, IoCall } from "react-icons/io5";
import { motion, AnimatePresence } from "framer-motion";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from 'react-router-dom';

const HomePage = () => {
    const [currentImage, setCurrentImage] = useState(0);
    const images = [homebanner1, homebanner2];
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const navigate = useNavigate();

    const handleNext = () => {
        setCurrentImage((prevImage) => (prevImage + 1) % images.length);
    };

    const handlePrev = () => {
        setCurrentImage((prevImage) => (prevImage - 1 + images.length) % images.length);
    };

    useEffect(() => {
        const interval = setInterval(handleNext, 7000);
        return () => clearInterval(interval);
    }, []);

    const textVariant = {
        hidden: { opacity: 0, y: 70 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 1.2, ease: "easeInOut" },
        },
    };

    const gridVariant = {
        hidden: { opacity: 0, y: 50 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 1.8,
                ease: "easeInOut",
                staggerChildren: 0.3,
            },
        },
    };

    const handleHelpSupportClick = () => {
        navigate('/contact-us');
        setIsPopupOpen(false);
    };


    const childVariant = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 1.2, ease: "easeInOut" },
        },
    };

    const slideVariants = {
        hidden: { x: "100%", opacity: 0 },
        visible: { x: "0%", opacity: 1, transition: { duration: 1, ease: "easeInOut" } },
        exit: { x: "-100%", opacity: 0, transition: { duration: 1, ease: "easeInOut" } },
    };

    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
            { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ]
    };

    const togglePopup = () => {
        setIsPopupOpen(!isPopupOpen);
    };

    return (
        <div>
            <div className="homepage">
                <div className="image-container">
                    <AnimatePresence>
                        <motion.img
                            key={currentImage}
                            src={images[currentImage]}
                            alt="Banner"
                            className="background-image"
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            variants={slideVariants}
                        />
                    </AnimatePresence>
                    <div className="image-overlay"></div>
                    <div className="content">
                        <div className="text-container custom-container-side">
                            <h1 className='font-merriweather custom-bottom-space'>THE COMPREHENSIVE MARKETPLACE FOR </h1>
                            <h2 className="title font-merriweather ">STEEL & POLYMER</h2>
                            <div className="subtitle font-merriweather custom-top-space">PRODUCTS</div>
                            <div className="buttons custom-top-space">
                                <button className="contact-btn font-poppins hover-border-4" onClick={togglePopup}>
                                    CONTACT US <MdOutlineArrowOutward />
                                </button>
                                <button className="read-more-btn font-poppins hover-border-4" onClick={() => navigate('/about-us')}>
                                    READ MORE <MdOutlineArrowOutward />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="arrow-container">
                        <button className="arrow left-arrow" onClick={handlePrev}>
                            <MdKeyboardArrowLeft className='icon-size' />
                        </button>
                        <button className="arrow right-arrow" onClick={handleNext}>
                            <MdKeyboardArrowRight className='icon-size' />
                        </button>
                    </div>
                </div>
            </div>

            {/* Popup Section */}
            {isPopupOpen && (
                <div className="popup">
                    <div className="popup-content">
                        <IoClose className="close-popup-icon" onClick={togglePopup} />
                        <h2 className="popup-title font-merriweather">
                            <FaHeadphonesAlt /> Connect with us
                        </h2>
                        <div className="contact-card">
                            <div className="contact-item">
                                <div className="contact-icon-circle">
                                    <IoCall className="contact-icon" />
                                </div>
                                <div className="contact-details font-lato">
                                    <p className="contact-title">Call us</p>
                                    <p className="contact-info">
                                        <a href="tel:+917011588280">+91 7011588280</a>
                                    </p>
                                    <p className="contact-subinfo">Mon-Fri | 10am to 7pm</p>
                                </div>
                            </div>
                            <div className="contact-item">
                                <div className="contact-icon-circle">
                                    <MdEmail className="contact-icon" />
                                </div>
                                <div className="contact-details font-lato">
                                    <p className="contact-title">Write to us</p>
                                    <p className="contact-info">
                                        <a href="mailto:info@stelmart.co.in">info@stelmart.co.in</a>
                                    </p>
                                </div>
                            </div>
                            <button className="help-support-button" onClick={handleHelpSupportClick}>
                                Help & Support
                            </button>                          </div>
                    </div>
                </div>
            )}

            <div className="features-section custom-inner-space custom-container-upper">
                <motion.h2
                    className="section-title font-merriweather"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    variants={textVariant}
                >
                    <span className="smart-india">SMART INDIA KA </span>
                    <span className="smart-marketplace">SMART MARKETPLACE</span>
                </motion.h2>

                <motion.p
                    className="section-subtitle font-merriweather"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    variants={textVariant}
                >
                    YOUR MODERN SOLUTION FOR A SMOOTH STEEL AND POLYMER SHOPPING EXPERIENCE.
                </motion.p>

                <Slider {...settings}>
                    {[
                        {
                            img: require("../../assets/images/icon/Component 2.png"),
                            text: "One-stop shop for all your steel and polymer needs.",
                            title: "Comprehensive Product Range",
                        },
                        {
                            img: require("../../assets/images/icon/Vector-2.svg").default,
                            text: "Simplified buying and selling with secure payments.",
                            title: "Swift Buying & Selling Experience",
                        },
                        {
                            img: require("../../assets/images/money-back.svg").default,
                            text: "Negotiate prices directly with buyers or sellers.",
                            title: "Competitive Pricing & Direct Negotiations",
                        },
                        {
                            img: require("../../assets/images/trucknew.svg").default,
                            text: "Stay informed with tracking and delivery notifications.",
                            title: "End-to-End Support",
                        },
                        {
                            img: require("../../assets/images/payment.svg").default,
                            text: "Access flexible financing options for smoother transactions.",
                            title: "Financial Assistance",
                        }
                    ].map((feature, index) => (
                        <motion.div
                            key={index}
                            className="feature"
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.2 }}
                            variants={textVariant}
                        >
                            <div className="icon">
                                <img src={feature.img} alt="icon" />
                            </div>
                            <div className="text">
                                <p className="font-poppins">{feature.text}</p>
                                <h3 className="font-merriweather">{feature.title}</h3>
                            </div>
                        </motion.div>
                    ))}
                </Slider>
            </div>
        </div>
    );
};

export default HomePage;
